var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30.5594 32L-3.12086e-05 1.44058L1.44055 3.66359e-07L31.9999 30.5594L30.5594 32Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.77855e-05 30.5595L30.5594 9.08618e-05L32 1.44067L1.4406 32.0001L1.77855e-05 30.5595Z","fill":"white","key":1})]);
}

Close.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Close;

Close.default = Close;
